<script>
  // https://github.com/EmilTholin/svelte-routing
  import { Router, Route } from 'svelte-routing'

  import { APP_LIST } from './appList'

  import Navbar from './Navbar.svelte'

  export let url = ''
</script>

<Router {url}>
  <!-- ナビバー -->
  <Navbar />

  <main class="content">
    <section class="section">
      <!-- デフォルト ページ。アプリ一覧を表示する -->
      <Route path="">
        {#each APP_LIST as { path: href, label, description, isSecret }}
          {#if !(isSecret || href === '/')}
            <div class="box">
              <a class="button is-primary block" {href}>{label}</a>
              <p>{description}</p>
            </div>
          {/if}
        {/each}
      </Route>

      <!-- 各アプリへのルート -->
      {#each APP_LIST as { path, component }}
        <!-- svelte-ignore missing-declaration -->
        <Route {path}><svelte:component this={component} /></Route>
      {/each}
    </section>
  </main>
</Router>
